import React, { Component } from 'react';
import AlbumArt from './AlbumArt';
import customchannels from './images/customchannels.png';

class RecentlyPlayed extends Component {

    render() {
        return (
            <div className="RecentlyPlayed">

              <h1>Recently Played</h1>
              <a rel="noopener noreferrer" className="CustomChannels" href="https://www.customchannels.net" target="_blank"><img src={ customchannels } alt="Custom Channels" /></a>
              <div className="clearfix"></div>
                { this.props.tracks.map(function(track, i){
                    var rowType = (i % 2 === 1 ? '' : 'odd');
                    return (
                    <div className={ rowType + " Track row" } key={ i }>
                        <AlbumArt albumArtUrl={ track.album_art.small } album={ track.album } />
                        <span className="Title">{ track.title } - <i>{ track.album }</i></span> <br />
                        <span className="Artist">{ track.artist }</span>
                    </div>
                    );
                })}
            </div>
        );
    }
}

export default RecentlyPlayed;



// WEBPACK FOOTER //
// ./src/RecentlyPlayed.js